export function getLocalStorageValue(key, initialValue) {
    const item = localStorage.getItem(key)

    return item ? JSON.parse(item) : initialValue
}

export function setLocalStorageValue(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
}

export function removeLocalStorageValue(key) {
    localStorage.removeItem(key)
}